import dayjs from 'dayjs';
import { TYPE_JOB } from 'constants/common';

/** Nhãn tiếng Việt cho cột/ô "Cách gửi"; giá trị gửi lên server vẫn là TYPE_JOB. */
export const JOB_TYPE_LABEL: Record<string, string> = {
  [TYPE_JOB.NOW]: 'Gửi ngay',
  [TYPE_JOB.CALENDAR]: 'Đặt lịch',
  [TYPE_JOB.NO]: 'Gửi thủ công',
};

export const JOB_TYPE_COLOR: Record<string, string> = {
  [TYPE_JOB.NOW]: 'magenta',
  [TYPE_JOB.CALENDAR]: 'blue',
  [TYPE_JOB.NO]: 'default',
};

// Thứ tự giữ như ô chọn cũ: Không / Đặt lịch / Gửi ngay.
export const JOB_TYPE_OPTIONS = [TYPE_JOB.NO, TYPE_JOB.CALENDAR, TYPE_JOB.NOW].map((value) => ({
  value,
  label: JOB_TYPE_LABEL[value],
}));

/**
 * Trạng thái hiển thị. Server chỉ ghi `status = 'SEND'` (và `isSend = true`) khi đã
 * gửi; chưa gửi thì status để trống. Tin đặt lịch mà quá giờ vẫn chưa gửi (vd. máy
 * chủ tắt đúng lúc đó) sẽ không tự gửi lại — cron chỉ lấy tin trong 5 phút tới.
 */
export const isJobSent = (record: any) => record?.status === 'SEND' || !!record?.isSend;

export function jobStatus(record: any): { label: string; color: string } {
  if (isJobSent(record)) {
    return { label: 'Đã gửi', color: 'green' };
  }
  if (record?.type === TYPE_JOB.CALENDAR) {
    if (record?.calendarDate && dayjs(record.calendarDate).isBefore(dayjs())) {
      return { label: 'Quá lịch, chưa gửi', color: 'red' };
    }
    return { label: 'Chờ đến lịch', color: 'gold' };
  }
  return { label: 'Chưa gửi', color: 'default' };
}
